import { adminAPI } from './api';

export const dashboardService = {
  // Get dashboard statistics - FIXED FIELD MAPPING
  getStats: async () => {
    try {
      console.log('📊 Fetching dashboard stats...');
      const response = await adminAPI.getDashboardStats();
      
      console.log('📈 Dashboard API Raw Response:', response.data);
      
      if (response.data && response.data.success) {
        const apiData = response.data.data || response.data || {};
        
        // ✅ MAP API FIELDS TO EXPECTED FIELD NAMES
        const mappedStats = {
          // Direct mappings from API
          totalUsers: apiData.total || 0,
          totalTutors: apiData.tutors || 0,
          totalStudents: apiData.students || 0,
          bannedUsers: apiData.banned || 0,
          
          // Fields that might come from API or default to 0
          pendingTutors: apiData.pendingTutors || apiData.pending_tutors || 0,
          totalAssignments: apiData.totalAssignments || apiData.assignments || apiData.total_assignments || 0,
          completedAssignments: apiData.completedAssignments || apiData.completed_assignments || 0,
          totalRevenue: apiData.totalRevenue || apiData.revenue || apiData.total_revenue || 0,
          totalCommissions: apiData.totalCommissions || apiData.commissions || apiData.total_commissions || 0,
          
          // Additional fields from API (if they exist)
          activeUsers: apiData.active || 0,
          newToday: apiData.newToday || apiData.new_today || 0
        };
        
        console.log('🔄 Mapped Stats:', mappedStats);
        
        return {
          success: true,
          data: mappedStats
        };
      } else {
        console.error('⚠️ Unexpected response format:', response.data);
        return {
          success: false,
          message: 'Invalid response format from server',
          data: {}
        };
      }
    } catch (error) {
      console.error('❌ Failed to fetch dashboard stats:', {
        message: error.message,
        status: error.response?.status,
        url: error.config?.url,
        data: error.response?.data
      });
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to load dashboard statistics',
        data: {}
      };
    }
  },

  // Get recent activities
  getRecentActivities: async (limit = 10) => {
    try {
      console.log('📝 Fetching recent activities...');
      const response = await adminAPI.getRecentActivities(limit);
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data || response.data || []
        };
      } else {
        return {
          success: true,
          data: []
        };
      }
    } catch (error) {
      console.error('❌ Failed to fetch recent activities:', error);
      return {
        success: true,
        data: [],
        message: 'Using sample data - API unavailable'
      };
    }
  },

  // Get platform growth data
  getPlatformGrowth: async (period = '7d') => {
    try {
      const response = await adminAPI.getPlatformGrowth(period);
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data || response.data || {}
        };
      } else {
        return {
          success: false,
          message: 'Invalid response format',
          data: {}
        };
      }
    } catch (error) {
      console.error('Failed to fetch platform growth:', error);
      return {
        success: false,
        message: 'Failed to load platform growth data',
        data: {}
      };
    }
  },
  
  // Alternative method to test endpoint
  testEndpoint: async () => {
    try {
      const response = await adminAPI.getDashboardStats();
      console.log('🧪 Endpoint Test Response:', {
        url: response.config?.url,
        status: response.status,
        data: response.data,
        structure: {
          hasData: 'data' in response.data,
          dataFields: response.data.data ? Object.keys(response.data.data) : [],
          rawFields: Object.keys(response.data)
        }
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('🧪 Endpoint Test Failed:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};